import React, { useState } from "react";
import { circle, circleCheckbox, lock, lockOpen, plus, searchs } from "../../assets";
import AvatarImage from "./../avatarImage";
import { fake } from "../../faker";
import { Modal } from "../Generic";
import { Link } from "react-router-dom";

const Message = () => {
  const [active, setActive] = useState("all");
  const [isVidModalOpen, setisVidModalOpen] = useState(false);
  const [isChildValueFalse, setIsChildValueFalse] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleChildValueChange = (newValue) => {
    setIsChildValueFalse(newValue);
  };
  const openVidModal = () => {
    setisVidModalOpen(true);
  };
  const closeVidModal = () => {
    setisVidModalOpen(setIsChildValueFalse);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  console.log(isChildValueFalse, handleChildValueChange)
  const useractive=false
  const locked = true;
  return (
    <div className="w-full max-w-[1100px] box-border px-[30px]">
      <div className="rounded-[12px] bg-blue-inputBlue  mt-[50px] items-center flex w-full h-[48px]">
        <div className="pl-[16px] pr-[12px]">
          <img className="opacity-40 w-[24px] h-[24px]" src={searchs} alt="" />
        </div>
        <input
          className="outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full"
          type="text"
          placeholder="Search message..."
        />
      </div>
      <div className="flex mb-[32px] gap-[13px] overflow-x-auto scroll mt-[14px]">
        <div
          onClick={() => setActive("all")}
          className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${
            active === "all"
              ? "bg-blue-activeSearchBlue"
              : " bg-gray-subjectGray"
          }`}
        >
          {/* <div><img className='w-[16px] opacity-50 h-[16px] sm:w-[22px] sm:h-[22px]' src={admin} alt="" /></div> */}
          <div className="text-[12px] sm:text-[16px] font-bold text-gray-lessonGray">
            All
          </div>
        </div>
        <div
          onClick={() => setActive("personal")}
          className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${
            active === "personal"
              ? "bg-blue-activeSearchBlue"
              : " bg-gray-subjectGray"
          }`}
        >
          {/* <div><img className='w-[16px] opacity-60 h-[16px] sm:w-[22px] sm:h-[20px]' src={videoIcon} alt="" /></div> */}
          <div className="text-[12px] sm:text-[16px] font-bold text-gray-lessonGray">
            Personal
          </div>
        </div>
        <div
          onClick={() => setActive("premium")}
          className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${
            active === "premium"
              ? "bg-blue-activeSearchBlue"
              : " bg-gray-subjectGray"
          }`}
        >
          {/* <div><img className='w-[16px] opacity-60 h-[16px] sm:w-[22px] sm:h-[22px]' src={group} alt="" /></div> */}
          <div className="text-[12px] sm:text-[16px] whitespace-nowrap font-bold text-gray-lessonGray">
            Premium users
          </div>
        </div>
        <div
          onClick={() => setActive("group")}
          className={`flex items-center hover:bg-blue-activeSearchBlue transition-all rounded-[11px] gap-[5px] cursor-pointer py-[5px] px-[20px] ${
            active === "group"
              ? "bg-blue-activeSearchBlue"
              : " bg-gray-subjectGray"
          }`}
        >
          {/* <div><img className='w-[16px] opacity-60 h-[16px] sm:w-[22px] sm:h-[22px]' src={group} alt="" /></div> */}
          <div className="text-[12px] sm:text-[16px] font-bold text-gray-lessonGray">
            Groups
          </div>
        </div>
      </div>

      {active === "personal" ? (
        fake.map((item) => (
          <Link to='/chat' className="border-y-gray-borderBottomGray w-full flex gap-[16px] border-y-solid py-[15px] border-y-[1px]">
            <div className="relative w-[43px] h-[45px] sm:w-[90px] sm:h-[100px]">
              {useractive &&
              <div className="h-[10px] w-[10px] sm:border-[4px] absolute z-10 top-0 bg-blue-chatBlue rounded-[50%] border-white border-solid border-[3px] right-0 box-content sm:w-[14px] sm:h-[14px]"></div>
              }
              <AvatarImage
                style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}
              />
            </div>
            <div className="w-full flex flex-col items-center justify-center sm:gap-[20px]">
              <div className="flex w-full justify-between items-center">
                <div className="font-[700] text-[14px] sm:text-[18px]">
                  Jane Cooper
                </div>
                <div className="text-[14px] ">1m ago</div>
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="w-[180px] sm:w-[300px] overflow-hidden ">
                  <div className="font-[500] text-[14px] sm:text-[16px] whitespace-nowrap">
                    IDK what else is there to do
                  </div>
                </div>
                <div className="text-[14px] bg-blue-chatBlue w-[20px] h-[20px] flex justify-center font-[500] text-white rounded-[50%]">
                  2
                </div>
              </div>
            </div>
          </Link>
        ))
      ) : active === "all" ? (
        fake.map((item) => (
          <Link to='/chat' className="border-y-gray-borderBottomGray w-full flex gap-[16px] border-y-solid py-[15px] border-y-[1px]">
            <div className="relative w-[43px] h-[45px] sm:w-[90px] sm:h-[100px]">
              {useractive && 
              <div className="h-[10px] w-[10px] sm:border-[4px] absolute z-10 top-0 bg-blue-chatBlue rounded-[50%] border-white border-solid border-[3px] right-0 box-content sm:w-[14px] sm:h-[14px]"></div>
              }
              <AvatarImage
                style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}
              />
            </div>
            <div className="w-full flex flex-col items-center justify-center sm:gap-[20px]">
              <div className="flex w-full justify-between items-center">
                <div className="font-[700] text-[14px] sm:text-[18px]">
                  Jane Cooper
                </div>
                <div className="text-[14px] ">1m ago</div>
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="w-[180px] sm:w-[300px] overflow-hidden ">
                  <div className="font-[500] text-[14px] sm:text-[16px] whitespace-nowrap">
                    IDK what else is there to do
                  </div>
                </div>
                {/* <div className="text-[14px] bg-blue-chatBlue w-[20px] h-[20px] flex justify-center font-[500] text-white rounded-[50%]">2</div> */}
              </div>
            </div>
          </Link>
        ))
      ) : active === "premium" ? (
        fake.map((item) => (
          <Link to='/chat' className="border-y-gray-borderBottomGray w-full flex gap-[16px] border-y-solid py-[15px] border-y-[1px]">
            <div className="relative w-[43px] h-[45px] sm:w-[90px] sm:h-[100px]">
              {useractive &&
              <div className="h-[10px] w-[10px] sm:border-[4px] absolute z-10 top-0 bg-blue-chatBlue rounded-[50%] border-white border-solid border-[3px] right-0 box-content sm:w-[14px] sm:h-[14px]"></div>
              }
              <AvatarImage
                style={`w-[40px] h-[40px] sm:w-[100px] sm:h-[100px]`}
              />
            </div>
            <div className="w-full flex flex-col items-center justify-center sm:gap-[20px]">
              <div className="flex w-full justify-between items-center">
                <div className="font-[700] text-[14px] sm:text-[18px]">
                  Jane Cooper
                </div>
                <div className="text-[14px] ">1m ago</div>
              </div>
              <div className="flex w-full justify-between items-center">
                <div className="w-[180px] sm:w-[300px] overflow-hidden ">
                  <div className="font-[500] text-[14px] sm:text-[16px] whitespace-nowrap">
                    IDK what else is there to do
                  </div>
                </div>
                <div className={`${locked ? "opacity-30" : ""}`}>
                  <img
                    className="h-[20px] w-[20px]"
                    src={locked ? lock : lockOpen}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </Link>
        ))
      ) : (
        <div>Groups soon..</div>
      )}
      <div
        onClick={openVidModal}
        className="bg-blue-chatBlue fixed bottom-[80px] right-[25px] rounded-[50%] sm:bottom-[100px] p-[20px] sm:right-[150px]"
      >
        <img src={plus} alt="" />
      </div>
      <Modal
        link={"/chat"}
        childrenStyle={"h-[400px]"}
        isOpen={isVidModalOpen}
        onClose={closeVidModal}
        modalName={"New Message"}
      >
        <div className="mx-[18px] max-w-[290px] sm:max-w-[400px]">
          <div className="rounded-[12px] bg-blue-inputBlue  my-[18px] items-center flex w-full h-[48px]">
            <div className="pl-[16px] pr-[12px]">
              <img
                className="opacity-40 w-[24px] h-[24px]"
                src={searchs}
                alt=""
              />
            </div>
            <input
              className="outline-none border-none sm:text-[18px] text-gray-usersGray bg-inherit w-full"
              type="text"
              placeholder="Search People..."
            />
          </div>
          <div className="pb-[12px] font-[700] text-[12px] sm:text-[14px] font-inter">
            Recommended
          </div>
        {
          fake.map((item)=>(
            <div className="flex w-full gap-[10px] items-center">
            <div><AvatarImage style={`h-[32px] sm:w-[40px] sm:h-[40px] w-[32px]`}/></div>
            <div className="flex justify-between w-full items-center">
              <div>
                <div className="text-[14px] font-[700] sm:text-[16px] ">Jane Cooper</div>
                <div className="text-[14px] text-gray-lightGray font-[500] sm:text-[16px]">@arleenmccy</div>
              </div>
              <div onClick={handleCheckboxChange}>
                <img  src={isChecked ? circleCheckbox : circle} alt="" />
              </div>
            </div>
          </div>
            ))}

        </div>
      </Modal>
    </div>
  );
};

export default Message;
